import SiteDetailController from './site.detail.controller';

export default {
    template: require('./site.detail.html'),
    controller: SiteDetailController
};
